import { AssetToken } from '..';
import React, { CSSProperties, useEffect, useState, useMemo } from 'react';

import { BaseSvgProps, SvgProps } from '../../svgIcons';

const SvgIconUrl: React.FC<
  React.PropsWithChildren<
    Partial<{
      style?: CSSProperties;
      width?: CSSProperties['width'];
      height?: CSSProperties['height'];
      symbol: SvgProps | string | null | undefined;
      dataAttribute: string;
      'data-test': string;
      className: string;
      onClick: ((event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void) | undefined;
      'data-active'?: boolean;
    }>
  >
> = React.memo(
  ({
    symbol = {
      viewBox: '',
      id: '',
      url: '',
    },
    className = '',
    onClick = () => undefined,
    dataAttribute = '',
    'data-test': dataAttr = '',
    style,
    width = '20rem',
    height = '20rem',
    ...rest
  }) => {
    const [resolvedSymbol, setResolvedSymbol] = useState<BaseSvgProps | null | undefined>(null);

    const iconClass = useMemo(() => `icon-svg ${className}`, [className]);
    const emptyClass = useMemo(() => `icon-svg icon-svg-empty ${className}`, [className]);

    useEffect(() => {
      if (symbol instanceof Promise) symbol.then(setResolvedSymbol);
    }, [symbol]);

    useEffect(
      () => () => {
        setResolvedSymbol(null);
      },
      [],
    );

    if (typeof symbol === 'string')
      return <AssetToken data-test={dataAttr ?? dataAttribute} symbol={symbol} className={className} />;

    if (!resolvedSymbol) {
      return <div className={emptyClass} />;
    }

    return (
      <svg
        data-symbol={resolvedSymbol.url}
        style={style}
        width={width}
        height={height}
        data-test={dataAttr ?? dataAttribute}
        onClick={onClick}
        className={iconClass}
        data-active={rest['data-active']}
        // viewBox={resolvedSymbol.viewBox}
      >
        <use xlinkHref={`#${resolvedSymbol.url}`} />
        {/* <use xlinkHref={resolvedSymbol.url || `#${resolvedSymbol.id}`} /> */}
      </svg>
    );
  },
);

export default React.memo(
  SvgIconUrl,
  (prevProps, nextProps) =>
    prevProps.symbol === nextProps.symbol &&
    prevProps.symbol === nextProps.symbol &&
    prevProps.className === nextProps.className &&
    prevProps.onClick === nextProps.onClick &&
    prevProps.dataAttribute === nextProps.dataAttribute &&
    prevProps['data-test'] === nextProps['data-test'] &&
    prevProps.style === nextProps.style &&
    prevProps.width === nextProps.width &&
    prevProps.height === nextProps.height &&
    prevProps['data-active'] === nextProps['data-active'],
);
